import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import Input from "@/components/common/Input";
import {ReactComponent as RiDeleteBinLine} from '@/assets/icons/ri-delete-bin-line.svg'
import {ReactComponent as RiTimeLine} from "@/assets/icons/ri-time-line.svg";
import {ReactComponent as RiAddLine} from "@/assets/icons/ri-add-line.svg";
import TimeInput from "@/components/common/TimeInput";
import Button from "@/components/common/Button";
import {hourFormat} from "@/utils";
import {priceSections, sectionDayWording, sectionValues} from "@/pages/Venues/Edit/contants";
import {hourRule} from "@/utils/validation";
import './index.css'

const onChangeTimeInput = (onChange: Function, e: Event) => {
  const target = e.target as HTMLInputElement
  onChange(target.value.split(':')[0])
}
const getPopulateData = (priceDataType, dayDataType) => ({
  type: priceDataType,
  day_type: dayDataType,
  start_time: hourRule.start,
  end_time: hourRule.end,
  price: null
})
const PricingForm = () => {
  const pricingMethods = useFormContext()
  
  const renderPriceDetails = (name, getFieldName) => {
    const {fields, remove} = useFieldArray({
      name,
      control: pricingMethods.control,
      keyName: 'generatedId'
    })
    return (
      <div className="flex flex-col w-full gap-2">
        {
          fields.map((p, index) => (
            <div key={p.generatedId} className="grid price-detail-row gap-3">
              <div className="flex-grow">
                <div
                  className="flex flex-grow flex-nowrap flex-row justify-between items-center py-2 px-4 bg-white-subtle border border-grey-line-subtle rounded">
                  <div className="flex gap-4 justify-start items-center">
                    <Controller
                      control={pricingMethods.control}
                      render={({field}) =>
                        <TimeInput
                          onChange={(e) => {
                            onChangeTimeInput(field.onChange, e)
                          }}
                          value={hourFormat(field.value)}/>}
                      name={getFieldName(index, 'start_time')}/>
                    <div> - </div>
                    <Controller
                      control={pricingMethods.control}
                      render={({field}) =>
                        <TimeInput
                          onChange={(e) => {
                            onChangeTimeInput(field.onChange, e)
                          }}
                          value={hourFormat(field.value)}/>}
                      name={getFieldName(index, 'end_time')}/>
                  </div>
                  <div className="flex justify-center items-center text-grey-dark h-4 w-4">
                    <RiTimeLine className="h-4 w-4"/>
                  </div>
                </div>
              </div>
              <div className="flex-grow">
                <Input
                  className="h-full"
                  name={getFieldName(index, 'price')}
                  type="number"
                  placeholder="Enter Price"
                  expanded/>
              </div>
              <button
                onClick={() => {
                  remove(index)
                }}
                type="button"
                className={`text-red-primary ${index !== 0 ? 'visible' : 'hidden'}`}>
                <RiDeleteBinLine/>
              </button>
            </div>
          ))
        }
      </div>
    )
  }
  const renderSectionDay = (priceSectionType: string, daySectionType: string, pm4) => {
    const name = `${priceSectionType}.${daySectionType}`
    const getFieldName = (index: number, key: string) => `${name}.${index}.${key}`
  
    const handleClickAddTimeRange = () => {
      const currentPricesOfSection = pm4.getValues(name)
      pm4.setValue(name, [...currentPricesOfSection, getPopulateData(priceSectionType, daySectionType)])
    }
    
    return (
      <div className="flex flex-col w-full border border-grey-line-subtle rounded p-4">
        <div className="text-jbase font-bold">{sectionDayWording[daySectionType].title}</div>
        <div className="text-jxs text-grey-dark mb-3">{sectionDayWording[daySectionType].days}</div>
        {renderPriceDetails(name, getFieldName)}
        <div>
          <Button
            onClick={handleClickAddTimeRange}
            type="button"
            variant="tertierry"
            className="whitespace-nowrap flex gap-2 pl-4 py-2 justify-center items-center mt-5 p-0 pl-0 py-0">
            <div className="w-[18px] text-red-primary">
              <RiAddLine/>
            </div>
            <span className="text-jsm">Add Time Range</span>
          </Button>
        </div>
      </div>
    )
  }
  const renderSectionDays = (priceSectionType: string, pm3) => (
    <div className="flex flex-col w-full gap-4">
      {sectionValues[priceSectionType].types.map((v) => (
        <div className="flex w-full" key={v.toString()}>
          {renderSectionDay(priceSectionType, v, pm3)}
        </div>
      ))}
    </div>
  )
  const renderPriceSection = (type: string, pm2) => (
    <div className="flex flex-col w-full gap-4 py-4 px-7 border border-grey-line-subtle rounded">
      <div className="text-jbase font-bold">{sectionValues[type].title}</div>
      {renderSectionDays(type, pm2)}
    </div>
  )
  const renderPriceSections = (pm1) => (
    <div className="flex flex-col w-full gap-4">
      {priceSections.map((ps, index) => (
        <div key={index.toString()} className='flex w-full justify-center items-center'>
          {renderPriceSection(ps, pm1)}
        </div>
      ))}
    </div>
  )
  
  return (
    <div className="flex flex-col w-full py-6 px-7">
      <div className="text-jsm font-medium mb-2">Price Class Name</div>
      <Input
        expanded
        name='name'
        type="text"
        className="mb-4"
        placeholder="Enter Price Class Name"
        validationSchema={{ required: true }}/>
      {renderPriceSections(pricingMethods)}
    </div>
  );
};

export default PricingForm;